var cio_config    = require("cio-config");
var Properties = cio_config.MetaProperties;
var lib_core    = require("lib-core");

var FootprintSettingsModel = function (data) {
    ui_extensions.SettingsModel.call(this, data);

    // TODO needs to be auto generated from some list of properties.
    var self = this;
    
    for(var key in Properties["footprint"]){
        if(Properties["footprint"].hasOwnProperty(key)){
            var info = Properties["footprint"][key];
            this[key] = createShadow(key, this.metaData[key], info.type, info.unit);
        }
    }

    var isValid = function(val) {
        if(typeof val != "string" && isNaN(val)){
            return false;
        } else if(val === null){
            return false;
        } else {
            return true;
        }
    };

    function createShadow(name, property, type, unit){
        return self.shadow(name, 
            function(){ 
                return property();
            },
            function(value){
                return validateAndSet(type, unit, value, property);
            },
            [property]
        );
    }

    function validateAndSet(type, unit, value, property){
        if(!type){
            // if no type, just set string.
            // TODO sanatise?
            return property(value);

        } else {

            if(unit){
                // convert to custom then convert because i want 'no unit' to be custom,
                // but we need to store in um
                var val = type.reader(value, unit);
                if(!isValid(val)) return false;
                val = cio_config.UnitConversions.convert(unit, "um", val);
                return property(val);

            } else {

                var val = type.parser(value);
                if(!isValid(val)) return false;
                return property(val);
            }
        }
    }

};

if(typeof window !== 'undefined') {
    var ui_extensions = require("ui-extensions");
    lib_core.inherit(FootprintSettingsModel, ui_extensions.SettingsModel);
}
FootprintSettingsModel.$class = 'FootprintSettingsModel';

module.exports = FootprintSettingsModel;
